import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { TransactionModel } from '@shared/models/TransactionModel';

@Component({
    selector: 'app-gsa-givi-sku-modal',
    templateUrl: './gsa-givi-sku-modal.component.html',
    styleUrls: ['./gsa-givi-sku-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class GsaGiviSkuModalComponent {

    @Input() givi: TransactionModel;

    constructor(public modalService: NgbModal) {
    }

    showSKUs(skuModal: any) {

        this.modalService.open(skuModal, {
            backdrop: 'static', keyboard: false, scrollable: true, centered: true, windowClass: 'modal-full'
        });
    }

}
